module.exports = __webpack_public_path__ + "img/speaker.933d3c48.png";